import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getProductMasterListApi = createAsyncThunk('getProductMasterList', async (payload) => {
  return await getProductMasterApi(payload);
});

const getProductMasterListSlice = createSlice({
  name: 'getProductMasterList', // Unique Name
  initialState,
  reducers: {
    getProductMasterListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductMasterListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getProductMasterListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getProductMasterListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getProductMasterListReset } = getProductMasterListSlice.actions;

export default getProductMasterListSlice.reducer;
